import { Injectable } from '@angular/core';

@Injectable()
export class HttpStatusService {

  constructor() { }

  setHttpStatus(status: number) {
    // do nothing in browser, because there's no HTTP here
  }

}



// WEBPACK FOOTER //
// ./src/app/core/http-status.service.ts